export default "__VITE_ASSET__CxpDV3Jh__"